<template>
  <div
    class="modal fade ag-modal"
    id="editDecision"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header p-0 pt-2 ag-card_navigation">
          <ul class="nav" id="ag-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <a
                class="nav-link active"
                id="ag-tab_editDecision"
                data-toggle="pill"
                href="#ag-tab_editDecision"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                {{ t("editDesicion") }}
              </a>
            </li>
          </ul>
        </div>
        <div class="modal-body">
          <form method="post" @submit.prevent="onSubmit">
            <div class="ag-add-decision p-4">
              <ul class="ag-add-decision-list">
                <li>
                  <span class="bold-text">{{$t("Role")}} </span>
                  <span class="value">{{ addDecision.rolePolicy }}</span>
                </li>
                <li>
                  <span class="bold-text">{{$t("Mode")}}</span>
                  <span class="value">{{ addDecision.modeName }}</span>
                </li>
                <li>
                  <span class="bold-text">{{$t("Action")}}</span>
                  <span class="value">{{ addDecision.action }}</span>
                </li>
                <li>
                  <span class="bold-text">{{$t("Actor")}}</span>
                  <span class="value">{{ addDecision.actor }}</span>
                </li>
                <li>
                  <span class="bold-text">{{$t("Target")}}</span>
                  <span class="value">{{ addDecision.target }}</span>
                </li>
                <li>
                  <span class="bold-text">Computers Affected :</span>
                  <span class="value"
                    >{{ addDecision.effectedComputerCount }} of
                    {{ addDecision.totalComputerCount }} ({{
                      addDecision.percentageComputer
                    }}%)</span
                  >
                </li>
                <li>
                  <span class="bold-text">{{$t("events")}} </span>
                  <span class="value">{{ addDecision.eventCount }}</span>
                </li>
                <li>
                  <span class="bold-text">{{$t("decision")}}</span>
                  <span class="value form-item">
                    <li
                      class="form-group"
                      v-for="(item, i) in decisions"
                      :key="i"
                    >
                      <label :for="item.name">
                        <input
                          type="radio"
                          :id="item.name"
                          :value="item.id"
                          name="decisionId"
                          v-model="addDecision.decisionId"
                        />
                        {{ item.decisionName }}
                      </label>
                    </li>
                  </span>
                </li>

                <li v-if="addDecision.decisionId !== 2">
                  <span class="bold-text">{{$t("option")}}</span>
                  <span class="value form-item">
                    <li class="form-group">
                      <select
                        name=""
                        id=""
                        class="form-control"
                        v-model="addDecision.decisionOptionId"
                      >
                        <option
                          v-for="(item, key) in options"
                          :key="key"
                          :value="item.key"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </li>
                  </span>
                </li>

                <li v-if="addDecision.decisionId !== 2">
                  <span class="bold-text">{{$t("saveAs")}}</span>
                  <span class="value form-item">
                    <li
                      class="form-group"
                      v-for="(item, i) in decisionStatuses"
                      :key="i"
                    >
                      <label :for="item.decisionStatusName">
                        <input
                          type="radio"
                          :id="item.decisionStatusName"
                          :value="item.id"
                          name="decisionStatus"
                          v-model="addDecision.decisionStatusId"
                          :disabled="item.id === 3"
                        />
                        <span v-if="item.id !== 3">
                          {{ item.decisionStatusName }}</span
                        >
                        <span style="color: #c9c8c8" v-else>
                          {{ item.decisionStatusName }}</span
                        >
                      </label>
                    </li>
                  </span>
                </li>

                <!-- <li>
                  <span class="bold-text">Scope : </span>
                  <span class="value form-item">
                    <li class="form-group">
                      <label for="group">
                        <input
                          type="radio"
                          id="group"
                          value="Group"
                          name="scope"
                          v-model="addDecision.scope"
                        />
                        {{$t("group")}}
                      </label>
                    </li>
                    <li class="form-group">
                      <label for="company">
                        <input
                          type="radio"
                          id="company"
                          value="Company"
                          name="scope"
                          v-model="addDecision.scope"
                        />
                        {{$t("Company")}}
                      </label>
                    </li>
                  </span>
                </li> -->
                <!-- <li style="margin-top: -22px">
                  <span class="bold-text"> </span>
                  <span class="value">
                    <p>
                      <small
                        >{{$t("decisionModalText")}}
                        <br />
                        {{$t("decisionModalText2")}}</small
                      >
                    </p>
                  </span>
                </li> -->
              </ul>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="
                  border-0
                  ag-button ag-button_radius
                  pr-4
                  pl-4
                  ag-button_secondary
                "
                data-dismiss="modal"
              >
                {{ t("cancel") }}
              </button>
              <button
                type="submit"
                class="
                  border-0
                  ag-button ag-button_radius
                  pr-4
                  pl-4
                  ag-button_primary
                  float-inline-end
                "
              >
                {{ t("save") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { ref } from "vue";
import api from "@/api/index";
import { useI18n } from "vue-i18n";

const store = useStore();
export default {
  name: "ag-add-decision-modal",
  data: () => ({
    addDecision: {
      id: "",
      eventId: "",
      rolePolicy: "",
      uniqueEventHash: "",
      mode: "",
      action: "",
      actor: "",
      target: "",
      effectedComputerCount: "",
      totalComputerCount: "",
      eventCount: "",
      percentageComputer: "",
      policyFileVersion: "",
      lastStatusChange: "",
      groupGuid: "",
      decisionId: "",
      decision: "",
      decisionStatusId: "",
      option: "",
      decisionStatus: "",
      scope: "",
    },
    scopes: [],
    modes: [],
    decisionStatuses: [],
    decisionOptions: [],
    decisions: [],
    options: [
      {
        key: 5,
        name: "Allow Launch (Default)",
      },
      {
        key: 4,
        name: "Add Power App",
      },
      {
        key: 3,
        name: "Add Power App For Parent",
      },
      {
        key: 2,
        name: "Add Trusted Folder",
      },
      {
        key: 1,
        name: "Add Trusted Folder For Parent",
      },
      {
        key: 6,
        name: "Configure Ignore Message",
      },
    ],
  }),
  setup() {
    const { t, locale } = useI18n();
    return {
      t,
    };
  },
  async mounted() {
    this.getList();
    const scopes = await api.policyReview.getScopes();
    this.scopes = scopes.data.entityData;
    const modes = await api.policyReview.getModes();
    this.modes = modes.data.entityData;
    const decisionStatuses = await api.policyReview.getDecisionStatus();
    this.decisionStatuses = decisionStatuses.data.entityData;
    const decisionOptions = await api.policyReview.decisionOptions();
    this.decisionOptions = decisionOptions.data.entityData;
    const decisions = await api.policyReview.getDecisions();
    this.decisions = decisions.data.entityData;
    this.setDefaults();
    this.setOptionsData();
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
  },
  watch: {
    onSubmit() {
      this.$emit("updateDecision", this.addDecision);
    },
    selectedRow() {
      this.getList();
      this.setOptionsData();
      this.setDefaults();
    },
    addDecision: {
      deep: true,
      handler() {
        store.dispatch(GeneralActionTypes.SET_SELECTED_ROW, this.addDecision);
      },
    },
  },
  methods: {
    setOptionsData() {
      if (this.addDecision.action === "Blocked Process") {
        this.options = [
          {
            key: 5,
            name: "Allow Launch (Default)",
          },
          {
            key: 4,
            name: "Add Power App",
          },
          {
            key: 3,
            name: "Add Power App For Parent",
          },
          {
            key: 2,
            name: "Add Trusted Folder",
          },
          {
            key: 1,
            name: "Add Trusted Folder For Parent",
          },
          {
            key: 6,
            name: "Configure Ignore Message",
          },
        ];
      }
      if (
        this.addDecision.action === "Blocked File Read" ||
        this.addDecision.action === "Blocked File Write"
      ) {
        this.options = [
          {
            key: 7,
            name: "Allow to Write / Read (Default)",
          },
          {
            key: 8,
            name: "Add Parent to Power App",
          },
          {
            key: 1,
            name: "Add Trusted Folder for Parent",
          },
          {
            key: 6,
            name: "Configure Ignore Message",
          },
        ];
      }
      if (
        this.addDecision.action === "Blocked Registry Read" ||
        this.addDecision.action === "Blocked Registry Write"
      ) {
        this.options = [
          {
            key: 7,
            name: "Allow to Write / Read (Default)",
          },
          {
            key: 8,
            name: "Add Parent to Power App",
          },
          {
            key: 1,
            name: "Add Trusted Folder for Parent",
          },
          {
            key: 6,
            name: "Configure Ignore Message",
          },
        ];
      }
      if (
        this.addDecision.action === "Blocked Memory Read" ||
        this.addDecision.action === "Blocked Memory Write"
      ) {
        this.options = [
          {
            key: 7,
            name: "Allow to Write / Read (Default)",
          },
          {
            key: 8,
            name: "Add Parent to Power App",
          },
          {
            key: 1,
            name: "Add Trusted Folder for Parent",
          },
          {
            key: 6,
            name: "Configure Ignore Message",
          },
        ];
      }
      if (this.addDecision.action === "Blocked Code Load") {
        this.options = [
          {
            key: 7,
            name: "Allow to Load (Default)",
          },
          {
            key: 8,
            name: "Add Parent to Power App",
          },
          {
            key: 1,
            name: "Add Trusted Folder for Parent",
          },
          {
            key: 6,
            name: "Configure Ignore Message",
          },
        ];
      }
    },
    setSelectedDecisionOption() {
      if (this.addDecision.action === "Blocked Process") {
        return 5;
      }
      if (
        this.addDecision.action === "Blocked File Read" ||
        this.addDecision.action === "Blocked File Write"
      ) {
        return 7;
      }
      if (
        this.addDecision.action === "Blocked Registry Read" ||
        this.addDecision.action === "Blocked Registry Write"
      ) {
        return 7;
      }
      if (
        this.addDecision.action === "Blocked Memory Read" ||
        this.addDecision.action === "Blocked Memory Read"
      ) {
        return 7;
      }
    },
    getList() {
      if (store.state.general.selectedExpandedRow) {
        this.addDecision = store.state.general.selectedExpandedRow;
      }
    },
    setDefaults() {
      try {
        this.addDecision.decisionId = this.addDecision.decisionId
          ? this.addDecision.decisionId
          : this.decisions.length > 0
          ? this.decisions[0].id
          : null;
        this.addDecision.decisionStatusId = this.decisionStatuses[0].id;
        this.addDecision.scope = this.addDecision.scope
          ? this.addDecision.scope
          : "Group";

        this.addDecision.decisionOptionId = this.addDecision.decisionOptionId
          ? this.addDecision.decisionOptionId
          : this.setSelectedDecisionOption();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
#exportJSON {
  margin-left: 0 !important;
  margin-bottom: 1.5rem;
}

.ag-data {
  height: 60vh;
  overflow: auto;
}

.ag-add-decision-list {
  list-style: none;
  padding: 0;
  margin: 15px 0;
  flex-wrap: wrap;
  width: 70%;
  margin: 0 auto;
}

.ag-add-decision-list label {
  font-size: 16px !important;
}

.ag-add-decision-list.wrap {
  padding-top: 70px;
  justify-content: center;
  align-items: center;
}

.ag-add-decision-list li {
  flex-direction: row;
  display: flex;
  list-style: none;
  margin: 0;
  padding: 6px 15px;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-start;
}

.ag-add-decision-list li .form-group {
  padding: 10px 0px;
}

.ag-add-decision-list li .bold-text {
  color: #5e5e5e;
  font-weight: bold;
  font-size: 16px;
  text-align: right;
  width: 30%;
}

.ag-add-decision-list li .value {
  color: #8e8e8e;
  font-size: 30px;
  color: #8e8e8e;
  font-size: 16px;
  margin-left: 10px;
  text-align: left;
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.ag-add-decision-list li .value.form-item {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: auto;
}

.ag-add-decision-list li .value.form-item .form-group {
  margin-right: 20px;
}
.ag-add-decision-list li .value.form-item .form-group label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.ag-add-decision-list li .value.form-item .form-group input[type="radio"] {
  margin-right: 8px;
}

input[type="radio"] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: #fff;
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: currentColor;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid currentColor;
  border-radius: 50%;
  transform: translateY(-0.075em);

  display: grid;
  place-content: center;
}

input[type="radio"]::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em #4c8dbb;
  background-color: #4c8dbb;
}

input[type="radio"]:checked::before {
  transform: scale(1);
}

input[type="radio"]:focus {
  outline: max(2px, 0.15em) solid #4c8dbb;
  outline-offset: max(2px, 0.15em);
}

.ag-add-decision-list li .raw {
  color: #8e8e8e;
  font-size: 12px;
}

.ag-add-decision-list.dropList {
  flex-direction: column;
  margin-top: 70px;
}

.ag-add-decision-list.dropList li {
  width: 100%;
}

.ag-modal .modal-body {
  background: #f8f8f8;
}

.ag-modal .modal-body textarea {
  border-color: #ddd;
  padding: 15px;
}

.ag-modal .modal-body label {
  color: #8e8e8e;
  font-size: 14px;
  margin: 0;
}
</style>